import { render, staticRenderFns } from "./HomeWantBuy.vue?vue&type=template&id=c4d25b46&scoped=true&"
import script from "./HomeWantBuy.vue?vue&type=script&lang=js&"
export * from "./HomeWantBuy.vue?vue&type=script&lang=js&"
import style0 from "./HomeWantBuy.vue?vue&type=style&index=0&id=c4d25b46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d25b46",
  null
  
)

export default component.exports